module.exports = __webpack_public_path__ + "static/media/imgBlog.b5df3166.png";